import sanitizeHtml from 'sanitize-html';

export default {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat([
    'video',
    'table',
    'dt',
    'q',
    'abbr',
    'em',
    'samp',
    'acronym',
    'font',
    'small',
    'address',
    'h1',
    'span',
    'b',
    'h2',
    'strike',
    'bdo',
    'h3',
    'strong',
    'big',
    'h4',
    'sub',
    'blockquote',
    'h5',
    'sup',
    'br',
    'h6',
    'caption',
    'hr',
    'tbody',
    'cite',
    'i',
    'td',
    'code',
    'img',
    'tfoot',
    'col',
    'ins',
    'th',
    'colgroup',
    'kbd',
    'thead',
    'dd',
    'li',
    'tr',
    'del',
    'ol',
    'tt',
    'dfn',
    'p',
    'ul',
    'div',
    'pre',
    'var',
    'dl',
    'iframe',
    'accordion-block',
    'table-list',
  ]),
  allowedAttributes: {
    ...sanitizeHtml.defaults.allowedAttributes,
    '*': [
      'alt',
      'face',
      'size',
      'background',
      'height',
      'src',
      'border',
      'href',
      'style',
      'class',
      'name',
      'target',
      'colspan',
      'rowspan',
      'width',
      'start',
      'data-list',
      'data-button-json',
      'data-json',
      'expand',
      'tracking',
    ],
  },
  allowedSchemesByTag: { a: ['http', 'https', 'mailto', 'tel', 'variable', 'custom-data', 'in-app', 'intent', 'form-url'] },
};
